// extracted by mini-css-extract-plugin
export default {"home":"c-h_es","home__content":"c-h_et"};